import React, { useEffect, useState } from 'react'; 
import Sidebar from './Sidebar'; 
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';
import Info from './Info';
import { format } from 'date-fns';
import { FaDownload } from 'react-icons/fa';

function Payment() { 
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [payment, setPayment] = useState([]); 
    useEffect(() => {
        document.title = 'Infomart | Agent Payment'; 
        setIsLoading(true);
        axios.get(`${BASE_URL}/agent/payment-list`, {
            headers: {  
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            } 
        }).then((res) => {
            setPayment(res.data.data);  
            setIsLoading(false);   
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }, []);
    return (
        <div className="app"> 
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    {isLoading ?
                        <h5 className="text-center mt-5">Loading...</h5> 
                    : 
                        <div> 
                            <div className="card">
                                <div className="card-header fw-bold">Payment</div>
                                {/* <div className="card-body">   */}
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr> 
                                                <th scope="col">#</th> 
                                                <th scope="col">Amount</th>
                                                <th scope="col">GST</th>
                                                <th scope="col">Total</th> 
                                                <th scope="col">Order ID</th>
                                                <th scope="col">Transaction ID</th> 
                                                <th scope="col">Date</th>
                                                <th scope="col">Status</th>  
                                                <th scope="col">Download</th>  
                                            </tr> 
                                        </thead>
                                        <tbody className="align-middle">
                                            {payment && payment.length > 0 ? (
                                                payment.map((data, i) => ( 
                                                    <tr key={i}>
                                                        <th scope="row">{i + 1}</th>  
                                                        <td>₹{data.amount}.00</td>
                                                        <td>₹{data.gst}.00</td>
                                                        <td>₹{data.total}.00</td> 
                                                        <td>{data.order_id}</td>
                                                        <td>{data.transaction_id}</td>
                                                        <td>{format(data.created_at, 'dd MMM, yyyy')}</td> 
                                                        <td>
                                                            {data.status == 'Success' ?
                                                                <span className="badge bg-success">Success</span>
                                                            :
                                                                <span className="badge bg-danger">Failed</span>
                                                            }  
                                                        </td>  
                                                        <td className="text-center">
                                                            {data.status == 'Success' ?
                                                                <a href={'/agent/invoice' + '/' + data.order_id} className="btn btn-primary btn-sm" target="_blank"><FaDownload /></a>
                                                            : 
                                                                <b>-</b>
                                                            } 
                                                        </td>    
                                                    </tr>    
                                                )) 
                                            ) : (
                                                <tr>
                                                    <th colSpan="6" className="text-center">No data available.</th>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>   
                                </div>
                            </div> 
                        </div>  
                    }
                </div>
            </div> 
        </div>
    );
}

export default Payment;            